module.exports = __webpack_public_path__ + "static/media/360layoutrevised-1.62291bc5.jpg";